import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute, Second } from '@nu-art/ts-common';
export const ApiDef_EncounterSimulation = {
    _v1: {
        createEncounterSimulation: { method: HttpMethod.POST, path: 'rehydration/rehydrate-encounter-data', timeout: Minute + (5 * Second) },
        getSimulationLaunchJwt: { method: HttpMethod.POST, path: 'rehydration/get-simulation-launch-jwt' },
        clearOldSimulations: { method: HttpMethod.POST, path: 'v1/encounter-simulations/clear-old-simulations' },
    }
};
//# sourceMappingURL=api-def.js.map